import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Quando o usuário está offline e não está na área offline, redireciona para /offline.
 * Funciona como fallback caso o Service Worker não tenha interceptado a navegação.
 */
export default function OfflineRedirect() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (navigator.onLine) return;
    if (pathname === '/offline' || pathname?.startsWith('/offline/')) return;
    window.location.replace('/offline');
  }, [pathname]);

  return null;
}
